import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
// import MoreVertIcon from '@material-ui/icons/MoreVert'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { expandLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { toggleContentIdVisibility, contentVisibilityKey } from '../../../../action/hidden-content-ids-actions'
import { lineDeleteRequest } from '../../../../action/line-actions'
import { markerDeleteRequest } from '../../../../action/marker-actions'
import { polygonDeleteRequest } from '../../../../action/polygon-actions'
import { circleDeleteRequest } from '../../../../action/circle-actions'
import { photoDeleteRequest as photoDeleteAction } from '../../../../action/photo-actions'
import { trackDeleteRequest } from '../../../../action/track-actions'
import { routeDeleteRequest } from '../../../../action/route-actions'
import { parseRouteGeoJson } from '../../../../lib/routeDocument'
import { selectedObjectIdNull } from '../../../../action/map-object-id'
import { boundaryDeleteRequest } from '../../../../action/boundary-actions'
import ConfirmRemoval from '../common/confirm-removal'
import { infoWindowOpenAction, infoWindowCloseAction } from '../../../../action/infowindow-action'

const MyContentItem = props => {
  const { data, mapReference, active, setActive, expandLeftToolbar, selectedObjectIdNull, map3d, is3dMapselected, type, hiddenContentIds, toggleContentIdVisibility } = props
  // Routes are always 'route', even before render-routes has drawn (and stamped) them.
  if (type === 'routes' || (!type && data.measurementTypeId === 2)) data.measureType = 'route'
  const { measureType, name } = data,
    [expanded, toggleExpand] = useState(false),
    [loadSpinner, setLoadSpinner] = useState(false),
    [confirmRemoval, setConfirmRemoval] = useState(false),
    menuRef = useRef(null),
    // The render-* layer hides an object by "kind:id" (kind = the concrete map
    // object type). Resolve it the same way the renderers key it: point items
    // (markers/hunt stands/photos) and tracks come straight from the section,
    // shapes carry a measureType once drawn and fall back to their geoJson shape.
    resolveKind = () => {
      const bySection = { markers: 'marker', huntStands: 'marker', photos: 'photo', tracks: 'track', routes: 'route' }
      if (bySection[type]) return bySection[type]
      if (measureType && measureType !== 'boundary') return measureType
      if (data.geoJson) {
        try {
          const feature = JSON.parse(data.geoJson).features?.[0]
          if (feature?.properties?.radius != null) return 'circle'
          const geomType = feature?.geometry?.type
          if (geomType === 'LineString' || geomType === 'MultiLineString') return 'line'
          if (geomType === 'Polygon' || geomType === 'MultiPolygon') return 'polygon'
        } catch (e) { /* fall through */ }
      }
      return null
    },
    kind = resolveKind(),
    // Favorite Locations (boundaries) are saved camera views with no map overlay,
    // so there is nothing to hide — omit the option there, as the per-type eye does.
    canHide = kind != null && type !== 'boundaries',
    isHidden = canHide && hiddenContentIds.includes(contentVisibilityKey(kind, data.id)),
    toggleHide = (e) => {
      e.stopPropagation()
      toggleContentIdVisibility(kind, data.id)
      toggleExpand(false)
    },
    cancelRemoval = () => {
      setConfirmRemoval(false)
      toggleExpand(false)
    },
    removeObject = () => {
      const deleteFunc = props[`${data.measureType}DeleteRequest`] || props.boundaryDeleteRequest
      setLoadSpinner(true)
      setTimeout(() => {
        setLoadSpinner(false)
      }, [1000 * 5])
      if (typeof data.mapObj == 'function') {
        data.mapObj().setMap(null)
      }
      cancelRemoval()
      props.setHideFunction(props.type)
      deleteFunc(data.id)
        .then((res) => {
          setLoadSpinner(false)
        })
        .catch((err) => {
          setLoadSpinner(false)
          console.log('error is at deleteFunc api', err)
        })
    },
    getIcon = () => {
      if (data.thumbnailUrl) {
        return data.thumbnailUrl
      }
      if (data.imageUrl) {
        return data.imageUrl
      }
      if (data.photo) {
        return data.photo.thumbnailUrl
      }
      if (measureType === 'marker') {
        const { markerTypeId } = data,
          url = props.markerTypes105.find(type => {
            return type.id === markerTypeId
          })
        return url ? url.iconUrl : ''
      }
      if (measureType === 'line') {
        return '../../../../../asset/Line_Dk_Green_Lg.png'
      }
      if (measureType === 'track') {
        return '../../../../../asset/Tracks_Dk_Green.png'
      }
      if (measureType === 'route') {
        return '../../../../../asset/mapToolsIcons/RouteBuilder.png'
      }
      if (measureType === 'circle') {
        return '../../../../../asset/Circle_Dk_Green_Lg.png'
      }
      if (measureType === 'polygon') {
        return '../../../../../asset/Draw-Shape_Thin_589500_ldpi.png'
      }
    },
    goTo = () => {
      const in3d = is3dMapselected && map3d && typeof map3d.easeTo === 'function'

      if (in3d) {
        try {
          if (measureType === 'circle') {
            // Use Google Maps circle bounds — still live behind the 3D overlay
            const bounds = data.mapObj?.()?.getBounds?.()
            if (bounds) {
              const sw = bounds.getSouthWest(), ne = bounds.getNorthEast()
              map3d.fitBounds([[sw.lng(), sw.lat()], [ne.lng(), ne.lat()]], { padding: 40, duration: 600 })
            }
          } else if (data.latitude != null && data.longitude != null) {
            // Point items: markers, photos, hunt stands
            map3d.easeTo({ center: [data.longitude, data.latitude], zoom: 17, duration: 600 })
          } else if (data.geoJson) {
            // Linear/area items: tracks, lines, polygons
            const gj = JSON.parse(data.geoJson)
            const coords = []
            const collect = (c) => { typeof c[0] === 'number' ? coords.push(c) : c.forEach(collect) }
            ;(gj.features || [gj]).forEach(f => { if (f?.geometry?.coordinates) collect(f.geometry.coordinates) })
            if (coords.length) {
              const lngs = coords.map(c => c[0]), lats = coords.map(c => c[1])
              map3d.fitBounds(
                [[Math.min(...lngs), Math.min(...lats)], [Math.max(...lngs), Math.max(...lats)]],
                { padding: 40, duration: 600 }
              )
            }
          } else if (data.mapBoundaryCamera) {
            const { targetLatitude: lat, targetLongitude: lng, zoom } = data.mapBoundaryCamera
            map3d.easeTo({ center: [lng, lat], zoom, duration: 600 })
          }
        } catch (e) {
          console.warn('goTo 3D error:', e)
        }
        return
      }

      // Routes fit their saved line (drawn or hidden alike).
      if (measureType === 'route') {
        const doc = parseRouteGeoJson(data.geoJson)
        if (doc && doc.coords.length) {
          const b = new google.maps.LatLngBounds()
          doc.coords.forEach(c => b.extend({ lat: c[1], lng: c[0] }))
          mapReference.fitBounds(b, { left: 20, top: 20, right: 20, bottom: 20 })
        } else console.warn('goTo: route has no geometry', data.id)
      }
      // Shapes carry a measureType (render-tracks/lines/polygons/circles mutate the
      // redux object in place), so they match here first.
      else if (measureType === 'track' || measureType === 'line' || measureType === 'polygon') {
        const path = data.mapObj ? data.mapObj().getPath() : null
        if (path) {
          const shapeBounds = new google.maps.LatLngBounds()
          path.forEach(pt => {
            try {
              shapeBounds.extend(pt)
            } catch (error) {
              console.warn('Could not extend shape bounds for user object: ', error)
            }
          })
          mapReference.fitBounds(shapeBounds, { left: 20, top: 20, right: 20, bottom: 20 })
        } else console.warn('Could not extend shape bounds: no path for', measureType)
      }
      else if (measureType === 'circle' && data.mapObj) {
        mapReference.fitBounds(data.mapObj().getBounds())
      }
      // Point items — markers, hunt stands, photos. render-markers renders a CLONE of
      // the redux object and stamps measureType/mapObj on the clone, so the object My
      // Content holds has NO measureType (and no mapObj). Match on coordinates instead
      // of measureType, mirroring the 3D branch above, so these actually center (WEB-7011).
      else if (data.latitude != null && data.longitude != null) {
        mapReference.setZoom(17)
        mapReference.setCenter({ lat: data.latitude, lng: data.longitude })
      }
      else if (data.mapBoundaryCamera) {
        const target = data.mapBoundaryCamera,
          latLng = new google.maps.LatLng({ lat: target.targetLatitude, lng: target.targetLongitude })
        mapReference.setCenter(latLng)
        mapReference.setZoom(target.zoom)
      } else {
        console.warn('goTo: no navigation target for type:', measureType)
      }
    },
    bgUrl = getIcon()

  useEffect(() => {
    // props.infoWindow && props.infoWindow.infoWindowFunction && setPovali(props.infoWindow.infoWindowFunction)
  }, [props.infoWindow])

  // Close the kebab menu when clicking anywhere outside this item.
  useEffect(() => {
    if (!expanded) return
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) toggleExpand(false)
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [expanded])

  const buildContent = (url, color, urlIcon) => {
    const hasSpaces = url.includes(' ');
    const imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
    // let colorMarker = color[0] === '#' ? color : '#' + color;
    let colorMarker
    if (color && color[0] == '#') {
      if (color.length <= 7) {
        colorMarker = color[0] == '#' ? color : '#' + color
      } else {
        colorMarker = color[0] == '#' ? color.substring(color.length == 8 ? 2 : color.length == 7 ? 1 : 0) : '#' + color.substring(color.length == 8 ? 2 : color.length == 7 ? 1 : 0)
      }
    } else {
      if (color && color.length <= 6) {
        colorMarker = color[0] == '#' ? color : '#' + color
      } else if (!color) {
        colorMarker = '#9ecc3b'
      }
      else {
        colorMarker = color && color[0] == '#' ? color && '#' + color.substring(color.length == 8 ? 2 : color && color.length == 7 ? 1 : 0) : '#' + color && color.substring(color.length == 8 ? 2 : '#' + color.length == 7 ? 1 : 0)
      }
    }
    return (
      <div>
        <svg
          className="default-size-marker-content"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          {/* Define the clipping path for the circle */}
          <defs>
            <clipPath id="circleClip">
              <circle cx="8" cy="6" r="5" />
            </clipPath>
          </defs>
          <rect width="16" height="16" id="icon-bound" fill="none" />
          <path
            d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
            fill={colorMarker[0] == '#' ? colorMarker : '#' + colorMarker}
          />
          <circle className="" cx="8" cy="6" r="5" fill="#FFFFFF" />

          {/* Image inside the circle with clipping path */}
          <image
            xlinkHref={imageUrl ? imageUrl : urlIcon}
            x="5"
            y="3"
            width="6"
            height="6"
            clipPath="url(#circleClip)"
          />
        </svg>
      </div>
    );
  };

  let onContentItemCLick = (e) => {
    e.stopPropagation()
    selectedObjectIdNull()
    setActive(data.id, data, props.infoWindow)
    goTo()
  }

  // Point markers/photos have no measureType in the My Content copy; shapes carry
  // one or a mapObj. Either way this gates Edit/Delete on the object being present.
  const canEditOrDelete = data.measureType === 'boundary' || data.measureType === 'route' || data.mapObj || !data.measureType

  return (
    <div className={`my-content-item ${active ? 'my-content-active' : ''}`} ref={menuRef}>
      {loadSpinner && <div className="loader-spinner-my-content"></div>}
      <div className='my-content-upper' onClick={onContentItemCLick}>
        {isHidden
          ? <div className='my-content-hidden-icon' title='Hidden on map'><VisibilityOff style={{ fontSize: 44, color: '#6E6E6E' }} /></div>
          : (data.markerType
            ? buildContent(data.markerType.vectorIconUrl, data.color, data.markerType.iconUrl)
            : <div className='my-content-icon' style={{ backgroundImage: `url(${bgUrl})` }}></div>)}
      </div>
      <div className='my-content-lower'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p className='my-content-text'>{name}</p>
          <MoreVertIcon
            className='my-content-kebab'
            onClick={(e) => {
              e.stopPropagation()
              setLoadSpinner(false)
              toggleExpand(!expanded)
            }}
            style={{ fontSize: '20px', textAlign: 'center' }} />
        </div>
      </div>
      {expanded ? (
        <div className='content-menu' onClick={(e) => e.stopPropagation()}>
          <div className='content-menu-item' onClick={(e) => {
            e.stopPropagation()
            toggleExpand(false)
            if (canEditOrDelete) {
              if (!data.measureType) data.measureType = 'boundary'
              goTo()
              expandLeftToolbar({ dialog: 'edit', editable: data })
            } else console.error('Cannot edit content due to missing JSON objects')
          }}>Edit</div>
          {canHide ? (
            <div className='content-menu-item' onClick={toggleHide}>
              {isHidden ? 'Show on Map' : 'Hide on Map'}
            </div>
          ) : null}
          <div className='content-menu-item content-menu-delete' onClick={(e) => {
            e.stopPropagation()
            if (canEditOrDelete) {
              setConfirmRemoval(true)
              toggleExpand(false)
            } else console.error('Cannot delete content due to missing JSON objects')
          }}>Delete</div>
        </div>
      ) : null}
      {
        confirmRemoval ? <ConfirmRemoval
          type={data.measureType}
          cancel={cancelRemoval.bind(this)}
          remove={removeObject.bind(this)}
        /> : null
      }
    </div >
  )
}

const mapStateToProps = state => ({
  mapReference: state.mapReference(),
  markerTypes105: state.markerTypes105,
  infoWindow: state.infoWindow,
  map3d: typeof state.mapReferenceThreed === 'function' ? null : state.mapReferenceThreed,
  is3dMapselected: state.is3dMapselected,
  hiddenContentIds: state.hiddenContentIds,
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: data => dispatch(expandLeftToolbar(data)),
  markerDeleteRequest: id => dispatch(markerDeleteRequest(id)),
  lineDeleteRequest: id => dispatch(lineDeleteRequest(id)),
  circleDeleteRequest: id => dispatch(circleDeleteRequest(id)),
  polygonDeleteRequest: id => dispatch(polygonDeleteRequest(id)),
  photoDeleteRequest: id => dispatch(photoDeleteAction(id)),
  trackDeleteRequest: id => dispatch(trackDeleteRequest(id)),
  routeDeleteRequest: id => dispatch(routeDeleteRequest(id)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload)),
  infoWindowCloseAction: () => dispatch(infoWindowCloseAction()),
  boundaryDeleteRequest: (id) => dispatch(boundaryDeleteRequest(id)),
  toggleContentIdVisibility: (kind, id) => dispatch(toggleContentIdVisibility(kind, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MyContentItem)